import { cloneDeep, isEmpty, partition, pick, unset } from 'lodash'

export const getPrinters = (state) => {
    const printers = cloneDeep(state?.printer?.byId)
    let localPrinter = pick(printers, 'local')?.local ?? {}
    let result = []

    if (!isEmpty(localPrinter) && localPrinter.state === 'connected') {
        result.push(localPrinter)
    }

    unset(printers, 'local')

    const [ receiptPrinters, nonReceiptPrinters ] = partition(printers, 'receiptPrinter')
    result = [ ...result, ...receiptPrinters, ...nonReceiptPrinters ]

    return result
}

export const getPrinter = (state, printerId) => {
    return state.printer.byId?.[printerId]
}
